/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'detectedDpi'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'colorGradation'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'heightMillis'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'widthMillis'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum];


